export const SURVEY_TIMEOUT_MESSAGE =
  'Sorry for the wait. The system is taking some time to load the survey list, and we are unable to return the results.';

export const SURVEY_SLOW_LOAD_THRESHOLD_MS = 7000;
